import gql from 'graphql-tag';
import { useEffect, useState } from 'react';
import useUtil from './useUtil';
import {
  getFromSessionStorage,
  setInSessionStorage,
} from '../../util/storage-utils';
import useInvoicePaymentAuthQuery from './useInvoicePaymentAuthQuery';
import { useServiceProviderInfo } from './useInvoicePaymentAccountInfo';
import { InvoiceDetailsList, InvoiceDetailsParams, InvoiceSortInput, Status } from '../../__generated__/pge-types';
import useInvoicePaymentAuth from './useInvoicePaymentAuth';

export enum TableControlsActions {
  PAGINATION,
  SEARCH,
  SORT,
  FILTER,
}

export type TableControlsType = (
  action: TableControlsActions,
  values: string | number | Status | InvoiceSortInput,
) => void;

export const GET_INVOICE_LIST_QUERY = gql`
  query GetInvoice($params: InvoiceDetailsParams!) {
    getInvoiceDetails(params: $params) {
      billsList {
          billId
          amountDue
          encryptedBillId
          billAmount
          projectAddress
          projectNum
          paymentAmount
          dueDate
          status
          }
          company
          companyAddress
          pagination {
            perPage
            totalPages
            totalResults
            page
          }
      }
  }
`;


const INVOICE_PAYMENT_INVOICE_LIST_FILTER = 'invoicePaymentInvoicefilter';

export enum InvoiceStatus {
  Paid = 'PAID',
  UnPaid = 'UNPAID',
  All = 'ALL'
}

export const useInvoiceList = () => {
  const { setErrorNotification } = useUtil();
  const [counter, setCounter] = useState<number>(2);
  const { authUser } = useInvoicePaymentAuth();

  const [input, setInput] = useState<InvoiceDetailsParams>(() => {
    const localstorageValue = getFromSessionStorage(
      INVOICE_PAYMENT_INVOICE_LIST_FILTER,
    );
    if (localstorageValue) {
      const savedValues: InvoiceDetailsParams = JSON.parse(localstorageValue);
      return JSON.parse(localstorageValue);
    }
    return {
      pagination: {
        offset: 1,
        limit: 10,
      }
    };
  });

  const { loading, data } = useInvoicePaymentAuthQuery<{
    getInvoiceDetails: InvoiceDetailsList;
  }>(GET_INVOICE_LIST_QUERY, {
    variables: {
      params: {
        cssUserEmail: authUser?.email,
        ...input
      }
    },
    context: {
      invoicePayment: true,
    },
    fetchPolicy: 'no-cache',
    skip: !authUser?.email,
    onError: () => setErrorNotification(true),
  });

  useEffect(() => {
    setInSessionStorage(
      INVOICE_PAYMENT_INVOICE_LIST_FILTER,
      JSON.stringify(input),
    );
  }, [input]);

  const tableControls = (
    action: TableControlsActions,
    value: Status | InvoiceSortInput | string | number,
  ) => {
    if (action === TableControlsActions.PAGINATION) {
      setInput({
       pagination: {
          offset: value as number,
          limit: 10,
        },
      });
      setCounter(prev => prev + 1);
      return;
    }
    if (action === TableControlsActions.SORT) {
      setInput({
        ...input,
        sort: { ...(value as InvoiceSortInput) },
        pagination: {
          offset: 1,
          limit: 10,
        },
      });
    }
    if (action === TableControlsActions.FILTER) {
      setInput({
        ...input,       
        status: value as Status,
        pagination: {
          offset: 1,
          limit: 10,
        },
      });
    }
     setCounter(2);
   };

  return {
    loading: loading,
    invoices: data?.getInvoiceDetails?.billsList,
    pagination: data?.getInvoiceDetails?.pagination,
    counter,
    tableControls,
    searchParams: input,
  };
};
